var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3673 6.25C12.7079 3.1875 11.3016 1.25 10.001 1.25C8.70039 1.25 7.29414 3.1875 6.63477 6.25H13.3673Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10C6.24985 10.8361 6.3056 11.6713 6.41688 12.5H13.5831C13.6944 11.6713 13.7502 10.8361 13.75 10C13.7502 9.16388 13.6944 8.32868 13.5831 7.5H6.41688C6.3056 8.32868 6.24985 9.16388 6.25 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63477 13.75C7.29414 16.8125 8.70039 18.75 10.001 18.75C11.3016 18.75 12.7079 16.8125 13.3673 13.75H6.63477Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6459 6.24965H18.5834C17.9917 4.90325 17.0928 3.71424 15.9587 2.77798C14.8246 1.84173 13.4868 1.18429 12.0527 0.858398C13.2384 1.90152 14.1684 3.83027 14.6459 6.24965Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0338 7.5H14.8463C14.9494 8.32934 15.001 9.16428 15.0007 10C15.0008 10.8357 14.949 11.6707 14.8457 12.5H19.0332C19.489 10.8645 19.489 9.1355 19.0332 7.5H19.0338Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0527 19.1413C13.487 18.8155 14.8251 18.1582 15.9594 17.2219C17.0937 16.2856 17.9929 15.0965 18.5846 13.75H14.6471C14.1684 16.1694 13.2384 18.0981 12.0527 19.1413Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35352 13.75H1.41602C2.00776 15.0965 2.90687 16.2856 4.04122 17.2219C5.17557 18.1582 6.51358 18.8155 7.94789 19.1413C6.76102 18.0981 5.83102 16.1694 5.35352 13.75Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94789 0.858398C6.51358 1.18411 5.17557 1.84147 4.04122 2.77774C2.90687 3.714 2.00776 4.90311 1.41602 6.24965H5.35352C5.83227 3.83027 6.76227 1.90152 7.94789 0.858398Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99934 10C4.99926 9.16426 5.05103 8.32933 5.15434 7.5H0.966845C0.511052 9.1355 0.511052 10.8645 0.966845 12.5H5.15434C5.05103 11.6707 4.99926 10.8357 4.99934 10Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.b49c02ae.svg";
export { ForwardRef as ReactComponent };